// extracted by mini-css-extract-plugin
export default {"container":"signin_container__cEr0D","block":"signin_block__lotR2","card":"signin_card__NtAKN","doubleInput":"signin_doubleInput__QtXL4"};